import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCrown, FaArrowRight } from 'react-icons/fa';
import { useCheckVipEligibilityQuery, useGetVipSettingsQuery } from '../../../features/vip-trading/vipTradingApiSlice';

interface VipTradingBannerProps {
  className?: string;
}

export const VipTradingBanner: React.FC<VipTradingBannerProps> = ({ className = '' }) => {
  const navigate = useNavigate();
  const { data: eligibility, isLoading: eligibilityLoading } = useCheckVipEligibilityQuery();
  const { data: settings, isLoading: settingsLoading } = useGetVipSettingsQuery();

  const isLoading = eligibilityLoading || settingsLoading;

  if (isLoading || !settings?.enabled) {
    return null;
  }

  const handleClick = () => {
    if (eligibility?.eligible) {
      navigate('/app/vip-trading');
    } else {
      navigate('/app/account/kyc');
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`w-full group relative overflow-hidden rounded-2xl p-4 md:p-6 bg-gradient-to-r from-yellow-500/10 via-orange-500/10 to-yellow-500/10 border border-yellow-500/30 hover:border-yellow-500/50 transition-all duration-300 ${className}`}
    >
      {/* Animated glow effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-yellow-500/5 to-transparent animate-shimmer" />

      <div className="relative flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="p-3 rounded-full bg-gradient-to-br from-yellow-500/20 to-orange-500/20 group-hover:scale-110 transition-transform">
            <FaCrown className="w-6 h-6 text-yellow-500" />
          </div>
          <div className="text-left">
            <h3 className="text-white font-semibold text-lg flex items-center gap-2">
              VIP Trading
              <span className="px-2 py-0.5 text-xs bg-yellow-500/20 text-yellow-400 rounded-full">
                PREMIUM
              </span>
            </h3>
            <p className="text-gray-400 text-sm">
              Sell ${settings?.minimumDepositUsd?.toLocaleString()}+ at exclusive VIP rates
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 text-yellow-500 group-hover:translate-x-1 transition-transform">
          <span className="hidden md:inline text-sm font-medium">
            {eligibility?.eligible ? 'Access VIP' : 'Complete KYC'}
          </span>
          <FaArrowRight className="w-4 h-4" />
        </div>
      </div>
    </button>
  );
};

export default VipTradingBanner;
